var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      },
      loaderButtonError: function(error) {
        _vm.submitError = error
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-layout",
                  { attrs: { "align-end": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md5: "", lg3: "" } },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              "close-on-content-click": false
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t(
                                          "recipientOrganizationName"
                                        ),
                                        hint: _vm.$t("transferHint"),
                                        "persistent-hint": "",
                                        rules: [_vm.fieldIsRequired()]
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return on.click.apply(null, arguments)
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      color: _vm.isOrgAddFavorite
                                                                        ? "yellow darken-2"
                                                                        : "grey light-2"
                                                                    },
                                                                    on: {
                                                                      click: function() {
                                                                        _vm.isOrgAddFavorite = !_vm.isOrgAddFavorite
                                                                      }
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "favorite"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "addToFavorites"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.toName,
                                        callback: function($$v) {
                                          _vm.toName = $$v
                                        },
                                        expression: "toName"
                                      }
                                    })
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.menuOrg,
                              callback: function($$v) {
                                _vm.menuOrg = $$v
                              },
                              expression: "menuOrg"
                            }
                          },
                          [
                            _vm._v(" "),
                            _vm.displayFavoriteOrgs &&
                            _vm.displayFavoriteOrgs.length
                              ? _c(
                                  "v-list",
                                  _vm._l(_vm.displayFavoriteOrgs, function(
                                    item
                                  ) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: item,
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return function() {
                                              return _vm.onSelectRecipient(item)
                                            }.apply(null, arguments)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", {
                                              domProps: {
                                                innerHTML: _vm._s(item)
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      return _vm.deleteRecipient(
                                                        item
                                                      )
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              },
                                              [_vm._v("delete")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { md1: "" } }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md5: "", lg3: "" } },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              "close-on-content-click": false
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: _vm.$t(
                                          "balanceReceiverOptional"
                                        ),
                                        hint: _vm.$t(
                                          "enterUserNameToReceiveTheBalance"
                                        ),
                                        "persistent-hint": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return on.click.apply(null, arguments)
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      color: _vm.isReceiverAddFavorite
                                                                        ? "yellow darken-2"
                                                                        : "grey light-2"
                                                                    },
                                                                    on: {
                                                                      click: function() {
                                                                        _vm.isReceiverAddFavorite = !_vm.isReceiverAddFavorite
                                                                      }
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "favorite"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "addToFavorites"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: _vm.userName,
                                        callback: function($$v) {
                                          _vm.userName = $$v
                                        },
                                        expression: "userName"
                                      }
                                    })
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.menuReceiver,
                              callback: function($$v) {
                                _vm.menuReceiver = $$v
                              },
                              expression: "menuReceiver"
                            }
                          },
                          [
                            _vm._v(" "),
                            _vm.displayFavoriteReceivers &&
                            _vm.displayFavoriteReceivers.length
                              ? _c(
                                  "v-list",
                                  _vm._l(_vm.displayFavoriteReceivers, function(
                                    item
                                  ) {
                                    return _c(
                                      "v-list-tile",
                                      {
                                        key: item,
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return function() {
                                              return _vm.onSelectReceiver(item)
                                            }.apply(null, arguments)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", {
                                              domProps: {
                                                innerHTML: _vm._s(item)
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return function() {
                                                      return _vm.deleteReceiver(
                                                        item
                                                      )
                                                    }.apply(null, arguments)
                                                  }
                                                }
                                              },
                                              [_vm._v("delete")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md10: "", lg6: "" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(tooltip) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, tooltip.on),
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            label: _vm.$t("modifiableTransfer")
                                          },
                                          model: {
                                            value: _vm.isModifiable,
                                            callback: function($$v) {
                                              _vm.isModifiable = $$v
                                            },
                                            expression: "isModifiable"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("modifiableTransferDesc")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ProductTableAndSelect", {
                  ref: "product_table_select",
                  attrs: {
                    submitError: _vm.submitError,
                    isBillingBalanceBelowCritical:
                      _vm.isBillingBalanceBelowCritical
                  },
                  model: {
                    value: _vm.productsSelected,
                    callback: function($$v) {
                      _vm.productsSelected = $$v
                    },
                    expression: "productsSelected"
                  }
                }),
                _vm._v(" "),
                _c("v-textarea", {
                  staticClass: "mt-3 thinBox",
                  attrs: {
                    id: "balance_note",
                    label: _vm.$t("note"),
                    outline: ""
                  },
                  model: {
                    value: _vm.note,
                    callback: function($$v) {
                      _vm.note = $$v
                    },
                    expression: "note"
                  }
                }),
                _vm._v(" "),
                _c("UploadFileWidget", {
                  attrs: {
                    type: "transfer",
                    maxFiles: 1,
                    removeFilesUponUnmounted: !_vm.isConfirmed,
                    isDisableCancelBtn: _vm.isLoading
                  },
                  model: {
                    value: _vm.uploadedFiles,
                    callback: function($$v) {
                      _vm.uploadedFiles = $$v
                    },
                    expression: "uploadedFiles"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-487a33fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487a33fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductTransferPopup.vue
// module id = null
// module chunks = 